const types = {
  stroke: [
    "home",
    "submenu_line",
    "plus",
    "reset",
    "logout",
    "download",
    "double_check",
    "x",
    "coins",
    "user_settings",
    "duplicate",
    "thief_protection_edit",
    "thief_protection",
    "secure",
    "not_secure",
  ],
  fill: [
    "device_management",
    "not_found",
    "import",
    "administration",
    "docs",
    "butler",
    "drag_and_drop",
    "service",
    "notifications",
    "fault",
    "check",
    "users",
    "arrow_down",
    "arrow_up",
    "arrow_right",
    "arrow_left",
    "customer",
    "cog",
    "edit",
    "euro",
    "trash",
    "building",
    "location",
    "load-change",
    "door-0",
    "door-25",
    "door-50",
    "door-75",
    "door-100",
    "door-closed",
    "door-opening-animation",
    "door-closing-animation",
    "list",
    "link-chain",
    "light_bulb",
    "history",
    "details",
    "export",
    "all_clear",
    "repair",
    "replace",
    "paperclip",
    "info-circle",
    "eye",
    "send_mail",
    "profile-circle",
  ],
};

const iconTypes: Map<string, string> = new Map<string, string>();
types.stroke.forEach((icon) => {
  iconTypes.set(icon, "stroke");
});
types.fill.forEach((icon) => {
  iconTypes.set(icon, "fill");
});

export const ICON_TYPES: Map<string, string> = iconTypes;
